// extracted by mini-css-extract-plugin
module.exports = {"scrollArea":"style_scrollArea__1_NnX","informationBox":"style_informationBox__yji2G","separatorLine":"style_separatorLine__n8BsW"};